import { keyframes } from 'styled-components';

/**
 * Extract from https://github.com/animate-css/animate.css/blob/main/animate.css
 * Version - 4.1.1
 */
export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

